import React from 'react';
import { SideSheet, SideSheetProps } from 'pounceV2';
import { HEADER_HEIGHT } from 'Components/Navigation/constants';
import NotificationsContainerV3 from 'Components/Notifications/NotificationsContainerV3';
import { useTheme } from '@mui/material';

const NotificationSidesheetV3 = ({ open, onClose }: SideSheetProps) => {
  const theme = useTheme();

  return (
    <SideSheet
      aria-label="notification center"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          top: HEADER_HEIGHT,
        },
      }}
      containerProps={{
        width: '25%',
        minWidth: '510px',
        maxWidth: '510px',
        p: 0,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.tokens.background.brand.dark.base,
        borderLeft: '1px solid',
        borderLeftColor: theme.palette.tokens.stroke.neutral[5],
        shadow: theme.palette.tokens.effects.shadows.base.base,
      }}
      hideDismissIcon
    >
      {open && <NotificationsContainerV3 />}
    </SideSheet>
  );
};

export default NotificationSidesheetV3;
